import { Select } from "antd";
import _ from "lodash";
import { useEffect } from "react";
import { loadOrganization } from "store/modules/workspace/workspace.helpers";
import { selectNewsfeedTypes } from "store/modules/workspace/workspace.selectors";
import { useQueryWithStore } from "store/store.hooks";

export const NewsfeedTypeSelector = ({
  value,
  onChange,
  autoSelectFirstOption,
  allowClear,
  autoFocus,
}: {
  value?: string;
  onChange?: (formId: string) => any;
  autoSelectFirstOption?: boolean;
  allowClear?: boolean;
  autoFocus?: boolean;
}) => {
  const { state: newsfeedTypes, retry: reload } = useQueryWithStore(
    selectNewsfeedTypes,
    loadOrganization,
  );

  useEffect(() => {
    // * Todo: Could properly rewrite this
    if (autoSelectFirstOption) {
      if (value) {
        if (!_.find(newsfeedTypes, { id: value })) {
          if (newsfeedTypes.length > 0) {
            onChange && onChange(newsfeedTypes[0].id!);
          }
          onChange && onChange(undefined!);
        }
      } else {
        if (newsfeedTypes.length > 0) {
          onChange && onChange(newsfeedTypes[0].id!);
        }
      }
    } else {
      if (value) {
        if (!_.find(newsfeedTypes, { id: value })) {
          onChange && onChange(undefined!);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoSelectFirstOption, newsfeedTypes]);

  return (
    <Select
      showSearch
      value={value}
      placeholder="Select Newsfeed Type"
      filterOption={false}
      onChange={onChange}
      style={{ width: "100%" }}
      allowClear={allowClear}
      defaultOpen={autoFocus}
      autoFocus={autoFocus}
    >
      {(newsfeedTypes || []).map((form) => (
        <Select.Option key={form.id} value={form.id!}>
          <div className="flex flex-row">
            <div className="icon-container mr-2">
              <i className="ri-settings-3-line"></i>
            </div>
            <div className="label">{form.label}</div>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};
